import React, { useState, useEffect } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import DevBlogForm from '../blog_form';
import useAuth from '../../../hooks/useAuth';
import { useGetBlogPostsQuery } from '../../../features/blog_posts/blogPostsApiSlice';

const DevBlog = () => {
  const { username } = useAuth();
  const [showForm, setShowForm] = useState(false);
  const { data: blogPosts, error, isLoading } = useGetBlogPostsQuery('blogposts', {
    pollingInterval: 15000, // Poll every 15 seconds
    refetchOnFocus: true, // Refetch data when the component is focused
    refetchOnMountOrArgChange: true, // Refetch data when the component is mounted or the query args change
  });
  const authorizedUsernames = ['dallasmoto'];

  useEffect(() => {
    if (error) {
      console.error('Error fetching blog posts:', error);
    }
  }, [error]);

  const handleFormSubmit = (values) => {
    console.log(values);
    // Call the API to create a new blog post using the provided values
    setShowForm(false);
  };

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  

  const sortedBlogPosts = blogPosts
    .slice()
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 10);

  return (
    <Container>
      <Typography variant="h2" mb={2}>
        Dev Blog
      </Typography>
      {authorizedUsernames.includes(username) && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Cancel' : 'Create New Blog Post'}
        </Button>
      )}
      {showForm && <DevBlogForm onSubmit={handleFormSubmit} />}
      {/* Add the search bar and list of blog posts here */}
      <Box
        mt={4}
      >
        {sortedBlogPosts.map((post) => (
          <Box key={post._id} mb={4}>
            <Typography variant="h4">{post.title}</Typography>
            <Typography variant="subtitle1" mb={1}>
              By {post.author}
            </Typography>
            <div className="ql-editor" dangerouslySetInnerHTML={{ __html: post.content }} />
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default DevBlog;